module.exports = __webpack_public_path__ + "static/media/clock-icon.d0fad3c7.svg";